import { render, staticRenderFns } from "./schoolApplicationForm.vue?vue&type=template&id=a070fe20&scoped=true"
import script from "./schoolApplicationForm.vue?vue&type=script&lang=js"
export * from "./schoolApplicationForm.vue?vue&type=script&lang=js"
import style0 from "./schoolApplicationForm.vue?vue&type=style&index=0&id=a070fe20&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a070fe20",
  null
  
)

export default component.exports